import React from 'react';
import { GLOBAL } from "../App";
import { Link } from "../components/ui/Link";
import { Page } from "../core/Page";
import styles from './TopPage.module.scss';
import { mergeClassNames } from '../utils/mergeClassNames';
import { VideoBG } from '../components/interface/VideoBG';

export class TopPage extends Page
{

	private _title:HTMLElement;
	private _tag:HTMLElement;

	componentDidMount()
	{
		window.addEventListener('resize', this._resize);
		window.addEventListener('load', this._resize);
		this._resize();
	}

	componentDidUpdate()
	{
		this._resize();
	}

	componentWillUnmount()
	{
		window.removeEventListener('resize', this._resize);
	}

	_resize = () =>
	{
		let changed = false;
		if(this._title && this._tag)
		{
			let p = this.props.data.title.indexOf('\n');
			let textNode:Text = this._title.querySelector('span').childNodes[0] as Text;

			if(textNode && p >= 0)
			{
				textNode.splitText(p - 1);
				let range = document.createRange();
				range.selectNodeContents(textNode);
				let bounds = range.getBoundingClientRect();
				let tBounds = this._title.getBoundingClientRect();
				let tagBounds = this._tag.getBoundingClientRect();

				let x = ((bounds.x + bounds.width * 1.13) >> 0) + 'px';
				let y = ((bounds.y - tBounds.y + bounds.height - tagBounds.height * 1.4) >> 0) + 'px';
				if(this._tag.style['left'] != x || this._tag.style['top'] != y)
				{
					this._tag.style['left'] = x;
					this._tag.style['top'] = y;
					console.log(x, y, this._tag.style['left'], this._tag.style['top']);
					changed = true;
				}
			}
		}

		if(changed)
		{
			setTimeout(this._resize, 100);
		}
	}

	protected static _styles = styles;
	render()
	{
		return (
			<>
				{
					this.props['props']['background']?(
						<div className={styles['video']}>
							<VideoBG controls={false} poster={this.props['props']['background']['image']} muted={true} autoPlay={true} playsInline={true} loop={true}>
								{
									this.props['props']['background']['video'].map((v, i) => {
										return (<source key={i} src={v['src']} type={v['type']}></source>);
									})
								}
							</VideoBG>
						</div>
					):null
				}
				<div className={styles['header']}>
					{this.props.data.title?(
						<h1 ref={r=>this._title = r}><span>{this.props.data.title}</span></h1>
					):null}
					{this.props.data.tag?(
						<div ref={r=>this._tag = r} className={styles['tag']}>{this.props.data.tag}</div>
					):null}
					{this.props.data.description?(
						<h2><span>{this.props.data.description}</span></h2>
					):null}
					{this.props.data.caption?(
						<div className={styles['caption']}><span>{this.props.data.caption}</span></div>
					):null}
					{
						this.props.data['links']?(
							<ul className={mergeClassNames(['links'], styles)}>
								{
									this.props.data['links'].map((l, i)=>{
										return (
											<li key={i}><Link href={GLOBAL.router.normalize(l['href'])} arrow={false}>{l['label']}</Link></li>
										);
									})
								}
							</ul>
						):null
					}
				</div>
			</>
		);
	}
}
